// PRE RMA — Téléchargement (export) et envoi (import) de fichiers : jeton d'authentification, messages d'erreur du serveur.
import { getSession } from './client.ts';

export const API_BASE: string = import.meta.env.VITE_API_BASE ?? '/api';
const entetes = (): Record<string, string> => { const t = getSession().token; return t ? { Authorization: `Bearer ${t}` } : {}; };

async function erreurServeur(res: Response): Promise<Error> {
  const corps = await res.json().catch(() => ({}));
  return new Error((corps as { erreur?: string }).erreur ?? `Erreur ${res.status}`);
}

/** Télécharge `url` (chemin complet, API_BASE compris) et l'enregistre sous `nomFichier`. Rejette avec un message lisible. */
export async function telechargerFichier(url: string, nomFichier: string): Promise<void> {
  const res = await fetch(url, { headers: entetes() });
  if (!res.ok) throw await erreurServeur(res);
  const blob = await res.blob();
  const lien = document.createElement('a');
  lien.href = URL.createObjectURL(blob);
  lien.download = nomFichier;
  document.body.appendChild(lien);
  lien.click();
  lien.remove();
  setTimeout(() => URL.revokeObjectURL(lien.href), 1500);
}

/** Envoie le fichier tel quel (corps binaire) à `chemin` (relatif à API_BASE) et renvoie la réponse JSON. */
export async function envoyerFichier<T>(chemin: string, fichier: File): Promise<T> {
  const res = await fetch(`${API_BASE}${chemin}`, { method: 'POST', headers: { ...entetes(), 'Content-Type': 'application/octet-stream' }, body: fichier });
  if (!res.ok) throw await erreurServeur(res);
  return (await res.json()) as T;
}

/** Comme telechargerFichier, mais en POST (le corps JSON porte les saisies manuelles à exporter : prix, quantités livrées…). */
export async function telechargerFichierPost(url: string, corps: unknown, nomFichier: string): Promise<void> {
  const res = await fetch(url, { method: 'POST', headers: { ...entetes(), 'Content-Type': 'application/json' }, body: JSON.stringify(corps) });
  if (!res.ok) throw await erreurServeur(res);
  const blob = await res.blob();
  const lien = document.createElement('a');
  lien.href = URL.createObjectURL(blob);
  lien.download = nomFichier;
  document.body.appendChild(lien);
  lien.click();
  lien.remove();
  setTimeout(() => URL.revokeObjectURL(lien.href), 1500);
}

/** Lit le contenu TEXTE d'un export (ex. liste des codes RSH en .txt) pour l'afficher ou le partager sans l'enregistrer. */
export async function lireTexteServeur(url: string): Promise<string> {
  const res = await fetch(url, { headers: entetes() });
  if (!res.ok) throw await erreurServeur(res);
  return res.text();
}
